import * as React from "react";
import Script from "next/script";

const MAPS_SCRIPT_SRC =
  "https://maps.googleapis.com/maps/api/js?v=weekly&key=AIzaSyBLoW8xoxv7aAt2BCAF0BclnscFRSkDkyI&libraries=places";

export const GoogleAutoComplete = ({ children, onChange, id = "google-autocomplete" }) => {
  const input = React.cloneElement(children, { ...children.props, id });
  const handlePlaceChange = (autocomplete) => () => {
    const place = autocomplete.getPlace();
    if (place) {
      onChange(place);
    }
  };

  const initMaps = () => {
    const element = document.getElementById(id);
    const autocomplete = new window.google.maps.places.Autocomplete(element, {
      types: ["address"],
      fields: ["formatted_address", "address_components"],
      componentRestrictions: { country: "fr" },
    });
    const eventListener = window.google.maps.event.addListener(
      autocomplete,
      "place_changed",
      handlePlaceChange(autocomplete)
    );

    return () => {
      window.google.maps.event.removeListener(eventListener);
    };
  };

  React.useEffect(() => {
    if (window?.google?.maps?.event) {
      initMaps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window]);

  return (
    <>
      <Script onLoad={initMaps} id={`gmaps-${id}`} src={MAPS_SCRIPT_SRC}></Script>
      {input}
    </>
  );
};
